import { Dispatch, SetStateAction } from "react";

export const periodTypes = [ "year", "month", "week", "day", "hour", "minute", "reboot" ] as const;
export type PeriodType = typeof periodTypes[number];

export const cronTypes = [ "period", "months", "month-days", "week-days", "hours", "minutes" ] as const;
export type CronType = typeof cronTypes[number];

export type SetValue = ((value: string, extra?: { selectedPeriod: PeriodType; }) => void) | Dispatch<SetStateAction<string>>

export type OnError = ((isError: boolean) => void) | undefined

export type AllowEmpty = "always" | "never" | "for-default-value"

export type LeadingZeroType = "month-days" | "hours" | "minutes"
export type LeadingZero = boolean | LeadingZeroType[]

export type ClockFormat = "24-hour-clock" | "12-hour-clock"

export type ShortcutsType = "@yearly" | "@annually" | "@monthly" | "@weekly" | "@daily" | "@midnight" | "@hourly" | "@reboot"
export type Shortcuts = boolean | ShortcutsType[]

export interface Locale {
  everyText?: string;
  emptyMonths?: string;
  emptyMonthDays?: string;
  emptyMonthDaysShort?: string;
  emptyWeekDays?: string;
  emptyWeekDaysShort?: string;
  emptyHours?: string;
  emptyMinutes?: string;
  emptyMinutesForHourPeriod?: string;
  yearOption?: string;
  monthOption?: string;
  weekOption?: string;
  dayOption?: string;
  hourOption?: string;
  minuteOption?: string;
  rebootOption?: string;
  prefixPeriod?: string;
  prefixMonths?: string;
  prefixMonthDays?: string;
  prefixWeekDays?: string;
  prefixWeekDaysForMonthAndYearPeriod?: string;
  prefixHours?: string;
  prefixMinutes?: string;
  prefixMinutesForHourPeriod?: string;
  suffixMinutesForHourPeriod?: string;
  errorInvalidCron?: string;
  clearButtonText?: string;
  weekDays?: string[];
  months?: string[];
  altWeekDays?: string[];
  altMonths?: string[];
}

export type SetValueNumbers = Dispatch<SetStateAction<number[]>>

export type SetValuePeriod = Dispatch<SetStateAction<PeriodType | null>>

export interface Unit {
  type: CronType;
  min: number;
  max: number;
  total: number;
  alt?: string[];
}